import { Pipe, PipeTransform } from '@angular/core';
import { AspectRatio } from 'qp-ui-interface';

@Pipe({
  name: 'imagesAspectRatioClass',
})
export class ImagesAspectRatioClass implements PipeTransform {
  /**
   * Transform card aspect ratio to class name for use in css
   *
   * @param ratio
   * @returns class name
   */
  transform(ratio: AspectRatio): string {
    return `image-parent__min-size image-parent__${ratio}`;
  }
}
